import React from 'react';
import EvaluationFormContext from '../../../components/context';
import QuestionGroup from './QuestionGroup';

export default class EvaluationQuestionList extends React.Component {
    static contextType = EvaluationFormContext;

    constructor(props) {
        super(props);
        this.state = {
            questionGroupArray: null,
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps != this.props){
            this._buildQuestionGroup();
        }
    }

    componentDidMount(){
        this._buildQuestionGroup();
    }

    _buildQuestionGroup(){
        let questionGroupList;
        if (this.context.loadingQuestions) {
            questionGroupList = <React.Fragment>
                <div className="question-mock shadow-depth-1">
                    <div className="question-mock__header bg-primary-placeholder shine"></div>
                </div>
                <div className="question-mock shadow-depth-1">
                    <div className="question-mock__header bg-primary-placeholder shine"></div>
                </div>
                <div className="question-mock shadow-depth-1">
                    <div className="question-mock__header bg-primary-placeholder shine"></div>
                </div>
                <div className="question-mock shadow-depth-1">
                    <div className="question-mock__header bg-primary-placeholder shine"></div>
                </div>
                <div className="question-mock shadow-depth-1">
                    <div className="question-mock__header bg-primary-placeholder shine"></div>
                </div>
            </React.Fragment>
        }else {
            let questionGroupKeysArr = [];
            this.context.questions.forEach((question)=>{
                questionGroupKeysArr.push(question.GROUP_DESC_SHORT);
            })
            questionGroupList = this.context.questions.map((questionGroup, groupKey) => {
                return <QuestionGroup 
                            class={groupKey % 2 == 1 ? "grey-group" : null} 
                            key={groupKey} 
                            questionGroup={questionGroup} 
                            questionGroupKeysArr={questionGroupKeysArr}
                        />
            })
        }

        this.setState({
            questionGroupArray : questionGroupList,
        })
    }

    render() {
        return (
            <div className={this.props.className}>
                {this.state.questionGroupArray}
            </div>
        );
    }
}